<div class="container">
  <h2 style="display:flex; justify-content:flex-start; align-items:center">
    <vng-icon name="keyboard_arrow_left" [outline]="false" (click)="nav.back()" style="cursor: pointer; margin-right: 10px; display: inline"
    ></vng-icon>
    <span style="font-weight: 700; font-size: 16px">Billing History</span>
  </h2>

  <section class="example-container" tabindex="0">
    <p>Manage your billing and payment history</p>

    <vng-empty-state *ngIf="dataSource.length < 1" title="No Invoices"></vng-empty-state>
    <!-- R8: billing-history is a plain-array table (dataSource is a plain []
         array, no MatTableDataSource/matSort ever existed here — same
         "markup-only conversion" as version-history, 03-component-mapping
         row 29) -> plain <table class="vng-table">. The Material CDK's
         `sticky: true` header-row behavior is reproduced with plain
         `position: sticky` CSS on `thead th` (billing-history.component.scss)
         inside the already-scrollable .example-container. -->
    <div class="vng-table-responsive" *ngIf="dataSource.length > 0">
      <table class="vng-table">
        <thead>
          <tr>
            <th>Plan</th>
            <th>Type</th>
            <th>Billing Date</th>
            <th>Status</th>
            <th>Amount</th>
            <th>Billing Reason</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of dataSource">
            <td>{{ element.plan_name }}</td>
            <td>{{ element.interval }}</td>
            <td>{{ element.billing_date }}</td>
            <td>
              <vng-badge [variant]="element.status === 'paid' ? 'success' : 'error'" [rounded]="true">{{
                element.status
              }}</vng-badge>
            </td>
            <td>${{ element.total }}</td>
            <td>{{ element.billing_reason }}</td>
            <td>
              <svg-icon-sprite
                (click)="downloadInvoice(element.invoice_pdf)"
                [vngTooltip]="'Download Invoice'"
                *ngIf="element.status === 'paid'"
                [id]
                [attr.style]="'display: inline-flex; cursor: pointer;'"
                [width]="24"
                [height]="24"
                src="icon-invoice"
              >
              </svg-icon-sprite>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
